import { DownloadBannerStatus } from 'models/Download';
import { createContext } from 'react';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import utils from 'utils';

type ShareableLinkFileDownloadContextProps = {
  showDownloadBanner: (status: DownloadBannerStatus) => void;
  openDownloadModal: (
    dataRoomId: string,
    nodes?: DataRoomNode[],
    baseLevelNodes?: DataRoomNode[],
  ) => void;
};

export default createContext<Partial<ShareableLinkFileDownloadContextProps>>({
  showDownloadBanner: utils.noop,
  openDownloadModal: utils.noop,
});
